import React, { useEffect, useState } from 'react';
import '../styles/Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    contactPreference: 'email'
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    const revealOnScroll = () => {
      const reveals = document.querySelectorAll('.reveal');
      reveals.forEach(element => {
        const windowHeight = window.innerHeight;
        const elementTop = element.getBoundingClientRect().top;
        const elementVisible = 150;
        
        if (elementTop < windowHeight - elementVisible) {
          element.classList.add('active');
        }
      });
    };

    window.addEventListener('scroll', revealOnScroll);
    revealOnScroll();

    return () => window.removeEventListener('scroll', revealOnScroll);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');

    // Validatie: als "Bel mij terug" is geselecteerd, moet er een telefoonnummer zijn
    if (formData.contactPreference === 'phone' && !formData.phone.trim()) {
      setIsSubmitting(false);
      setSubmitMessage('Vul een telefoonnummer in als je teruggebeld wilt worden.');
      return;
    }

    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          access_key: '0d2ee373-abf7-4b66-92d6-3167415e0134',
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          message: formData.message,
          contact_preference: formData.contactPreference,
        }),
      });

      const result = await response.json();

      if (result.success) {
        setIsSubmitting(false);
        setIsSubmitted(true);
        setSubmitMessage('Bedankt voor je bericht! Ik neem zo snel mogelijk contact met je op.');
        setFormData({
          name: '',
          email: '',
          phone: '',
          message: '',
          contactPreference: 'email'
        });
      } else {
        throw new Error('Verzenden mislukt');
      }
    } catch (error) {
      setIsSubmitting(false);
      setSubmitMessage('Er ging iets mis bij het verzenden. Probeer het opnieuw of neem direct contact op via LinkedIn/Instagram.');
    }
  };

  return (
    <section className="contact" id="contact">
      <div className="container">
        <div className="contact-content reveal">
          <h2 className="section-title">Contact</h2>
          
          {!isSubmitted ? (
            <>
              <div className="contact-intro">
                <p>Ik kijk uit naar een nieuwe vaste plek waar ik echt iets kan betekenen.</p>
                <p>Zie je een match? Ik hoor het graag, het liefst bij een kop koffie.</p>
              </div>

              <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Naam *</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="Je naam"
              />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="email">E-mail *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="je@email.nl"
                />
              </div>

              <div className="form-group">
                <label htmlFor="phone">Telefoon</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="06-12345678"
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="message">Bericht *</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows="5"
                placeholder="Vertel me over je project of vraag..."
              />
            </div>

            <button 
              type="submit" 
              className="btn btn-submit"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Verzenden...' : 'Verstuur bericht'}
            </button>

              {submitMessage && (
                <div className="submit-message success">
                  {submitMessage}
                </div>
              )}
            </form>
            </>
          ) : (
            <div className="submit-success">
              <div className="submit-message success">
                {submitMessage}
              </div>
            </div>
          )}

          <div className="contact-alternative">
            <p>Liever direct contact?</p>
            <p>Stuur een bericht via LinkedIn of Instagram</p>
            <div className="social-links">
              <a
                href="https://www.linkedin.com/in/evabaris"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                LinkedIn
              </a>
              <a
                href="https://www.instagram.com/eva.baris"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                Instagram
              </a>
            </div>
          </div>

          <div className="cv-download">
            <p>Nóg meer over mij?</p>
            <a
              href="/CV-Eva-Baris.pdf"
              target="_blank"
              rel="noopener noreferrer"
              download
              className="download-cv"
              aria-label="Download CV"
            >
              Download CV
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;